<template>
  <section class="py-10 md:py-20 bg-white">
    <div class="container mx-auto px-4">
      <div class="flex flex-col md:flex-row items-center">
        <div
          class="w-full md:w-1/2 mb-8 md:mb-0"
          style="aspect-ratio: 16/9; max-height: 315px"
        >
          <div class="relative h-full">
            <div
              class="relative group video-container rounded-xl overflow-hidden h-full bg-black"
            >
              <div
                v-if="!isPlaying"
                class="absolute inset-0 w-full h-full bg-cover bg-center flex items-center justify-center transition-opacity duration-300"
                :style="{ backgroundImage: 'url(' + coverImage + ')' }"
              >
                <div
                  class="youtube-play-button cursor-pointer"
                  @click="playVideo"
                >
                  <div class="youtube-play-icon"></div>
                </div>
              </div>

              <iframe
                v-if="isPlaying"
                class="w-full h-full"
                src="https://www.youtube-nocookie.com/embed/qVdo3XSAtko?autoplay=1"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>

            <div class="text-center my-2 text-[#555] text-sm tracking-wider">
              CLICK TO WATCH VIDEO
            </div>
          </div>
        </div>

        <div class="w-full md:w-1/2 md:pl-12 lg:pl-24">
          <div
            class="text-2xl md:text-title font-bold text-[#333333] leading-tight mb-4 md:mb-6 uppercase"
          >
            Company Introduction
          </div>
          <div
            class="text-desc text-sm md:text-base leading-relaxed text-gray-600"
          >
            Deer Gifts Co., LTD, a Zhongshan-based metal products manufacturer,
            has offered keychains, medals, coins, and lapel pins since 2004.
            With our own OEM/ODM framework, we maintain strict quality control
            from raw material inspection to final packaging. Adhering to BSCI
            and ISO14001 standards, we hold certifications like EN71,REACH, and
            Rohs CE from SGS and TUV, ensuring competitive pricing, reliable
            quality, and timely delivery recognized by partners globally for
            years.
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Template',
  data() {
    return {
      isPlaying: false,
      coverImage: require('@/assets/web_pg_vo.jpg')
    }
  },
  methods: {
    playVideo() {
      this.isPlaying = true
    }
  }
}
</script>

<style scoped>
/* 基础样式保持，主要调整可见性逻辑 */
.youtube-play-button {
  width: 68px;
  height: 48px;
  background-color: #ff0033;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  /* 关键修改：移动端必须可见，否则用户不知道可以点击 */
  opacity: 0.9;
}

/* 仅在具有鼠标指针的设备上启用 Hover 隐藏效果 */
@media (min-width: 1024px) {
  .youtube-play-button {
    opacity: 0;
  }
  .video-container:hover .youtube-play-button {
    opacity: 1;
    transform: scale(1.1);
  }
}

.youtube-play-button:active {
  transform: scale(0.95);
  background-color: #cc0000;
}

.youtube-play-icon {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 16px solid white;
  margin-left: 4px;
}

/* 确保 text-desc 在移动端也清晰 */
.text-desc {
  text-align: justify;
}
@media (min-width: 768px) {
  .text-desc {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/index/magazineModulesSection.vue